import { IObservable, SeenTracker, Subject } from '~/rage/utils';
import { Gender, TattooCategory, WalletType } from '~/shared';
import { ITattooShopService, TattooItemConfig } from './tattooShopServiceTypes';

export class TattooShopServiceStub implements ITattooShopService {
	private items = new Subject<TattooItemConfig[]>([
		{
			id: 'tattoo_1',
			name: 'Татуировка 1',
			categoryId: TattooCategory.HEAD,
			price: 1000,
			isEnabled: true,
			gender: Gender.COMMON,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_12',
			name: 'Татуировка 12',
			categoryId: TattooCategory.HEAD,
			price: 1000,
			isEnabled: true,
			gender: Gender.FEMALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_13',
			name: 'Татуировка 12',
			categoryId: TattooCategory.HEAD,
			price: 1000,
			isEnabled: true,
			gender: Gender.FEMALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_14',
			name: 'Татуировка 12',
			categoryId: TattooCategory.HEAD,
			price: 1000,
			isEnabled: true,
			gender: Gender.FEMALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_2',
			name: 'Татуировка 2',

			price: 2000,
			isEnabled: true,
			categoryId: TattooCategory.NECK,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_3',
			name: 'Татуировка 3',
			categoryId: TattooCategory.ARM_RIGHT,
			price: 3000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_4',
			name: 'Татуировка 4',
			categoryId: TattooCategory.ARM_LEFT,
			price: 4000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_5',
			name: 'Татуировка 5',
			categoryId: TattooCategory.BREAST,
			price: 5000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_6',
			name: 'Татуировка 6',
			categoryId: TattooCategory.BELLY,
			price: 6000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_7',
			name: 'Татуировка 7',
			categoryId: TattooCategory.BACK_BODY,
			price: 6000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_8',
			name: 'Татуировка 8',
			categoryId: TattooCategory.LEG_RIGHT,
			price: 6000,
			isEnabled: true,
			gender: Gender.FEMALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_81',
			name: 'Татуировка 81',
			categoryId: TattooCategory.LEG_RIGHT,
			price: 6000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_9',
			name: 'Татуировка 9',
			categoryId: TattooCategory.LEG_LEFT,
			price: 6000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		...Array.from({ length: 100 }, (_, index) => ({
			id: `tattoo_${index + 30}`,
			name: `Татуировка ${index + 30}`,
			categoryId: TattooCategory.HEAD,
			price: 1000,
			isEnabled: true,
			gender: Gender.COMMON,
			hash: 4321,
			collectionHash: 1234,
		})),
	]);

	private ownedTattoos = new Subject<TattooItemConfig[]>([
		{
			id: 'tattoo_6',
			name: 'Татуировка 6',
			categoryId: TattooCategory.BELLY,
			price: 6000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
		{
			id: 'tattoo_7',
			name: 'Татуировка 7',
			categoryId: TattooCategory.BACK_BODY,
			price: 6000,
			isEnabled: true,
			gender: Gender.MALE,
			hash: 4321,
			collectionHash: 1234,
		},
	]);

	private tattooDeletionPrice = new Subject(1000);
	private seenTracker = new SeenTracker(null);

	public getItems(): IObservable<TattooItemConfig[]> {
		return this.items;
	}

	public getOwnedTattoos(): IObservable<TattooItemConfig[]> {
		return this.ownedTattoos;
	}

	public async buyTattoo(
		tattooId: string,
		walletType: WalletType,
	): Promise<void> {
		const newTattoo = this.items
			.getValue()
			.find((item) => item.id === tattooId)!;
		const currentTattoos = this.ownedTattoos.getValue();

		const filteredTattoos = currentTattoos.filter(
			(tattoo) => tattoo.categoryId !== newTattoo.categoryId,
		);

		this.ownedTattoos.next([...filteredTattoos, newTattoo]);

		console.log('tattooShop: buyTattoo', tattooId, walletType);
	}

	public async previewTattoo(tattooId: string): Promise<void> {
		console.log('tattooShop: previewTattoo', tattooId);
	}

	public async previewTattooCategory(
		category: TattooCategory | 'delete' | null,
	): Promise<void> {
		console.log('tattooShop: previewTattooCategory', category);
	}

	public getTattooDeletionPrice(): Subject<number> {
		return this.tattooDeletionPrice;
	}

	public async deleteTattoo(
		tattooId: string,
		walletType: WalletType,
	): Promise<void> {
		const currentTattoos = [...this.ownedTattoos.getValue()];
		const filteredTattoos = currentTattoos.filter(
			(tattoo) => tattoo.id !== tattooId,
		);

		this.ownedTattoos.next(filteredTattoos);

		console.log('tattooShop: deleteTattoo', tattooId, walletType);
	}

	public isUnseen(path: string): boolean {
		return this.seenTracker.isUnseen(path);
	}

	public markSeen(path: string): void {
		console.log('tattooShop:markSeen', path);
		this.seenTracker.markAsSeen(path);
	}

	public async exitMenu(): Promise<void> {
		console.log('tattooShop: exitMenu');
	}
}
